

    function rearrangeOverflowedOverlays(flag) {

        var selectors = [{ "parent": ".f01-featured-item.featured-item-slide-topic", "child": ".featured-item-slide-title-copy" },
        { "parent": ".f01-featured-item.featured-item-title-overlay", "child": ".featured-item-title.field-title" },
        { "parent": ".screen-title.screen-title-overlay", "child": ".screen-title-title.field-title" },
        { "parent": ".component.t04-screen-title", "child": ".screen-title-copy" },
        ];

        var width = $(document).width();
        if (width >= 768) {
            if (flag) {
                selectors.forEach(function (parentSelector) {
                    $(parentSelector.parent).each(function () {
                        var component = $(this);
                        var childelement = parentSelector.child;
                        var overlayheightEl = component.find(childelement);
                        overlayheightEl.removeClass('rearrange-overlay');
                    });
                });
            }
            selectors.forEach(function (parentSelector) {
                $(parentSelector.parent).each(function () {
                    var component = $(this);
                    var childelement = parentSelector.child;
                    var interval = setInterval(function () {
                        var imgheight = component.find('.component.b03-image').height();
                        if (imgheight > 50) {
                            var overlayheightEl = component.find(childelement);
                            var overlayheight = overlayheightEl.height() + 30;
                            console.log(imgheight, overlayheight);
                            if (overlayheight >= imgheight) {
                                overlayheightEl.addClass('rearrange-overlay');
                                clearInterval(interval);
                            } else {
                                // overlayheightEl.removeClass('rearrange-overlay');
                            }
                            clearInterval(interval);
                        }

                    }, 2000);


                });
            });
        }

    }
    //brought from custom-component.js
    var lastWidthCheck = window.innerWidth; // Track width changes
    var lastHeightCheck = window.innerHeight; // Track height for scroll detection

(function ($) {
    $(window).on("load", function () {
        rearrangeOverflowedOverlays(false);
    });

    $(window).on("resize", function () {
        var currentWidth = window.innerWidth;
        var currentHeight = window.innerHeight;

        // **Scenario 1: Prevent calls on iPad scroll**
        if (Math.abs(currentHeight - lastHeightCheck) < 50) {
            // If height change is small (likely an iPad scroll), ignore
            return;
        }

        // **Scenario 2: Allow function only on actual width resizes**
        if (currentWidth !== lastWidthCheck) {
            rearrangeOverflowedOverlays(true);
            lastWidthCheck = currentWidth;
        }

        // Update height check for future scroll detection
        lastHeightCheck = currentHeight;
    });
}(window.jQuery));



    function locatorMapGAEventsHandler() {
        $('map').on('customClick', function (e) {
            $(this).trigger('pinClick');
        });

        // I wish we didn't need to do this...
        $('map').on('customPopupClick click', function (e) { //customPopupClick
            var $target = $(e.target);

            if ($target.is('a')) {
                var title = $target.parents('.info-window').find('h6');
                if (title.length === 0) {
                    title = $target.parents('.info-window').find('.product-list-title');
                }
                var hrefValue = $target.attr("href");
                targetUrl = hrefValue.indexOf("javascript") > -1 ? ($target.attr("data-destinationUrlValue") ? $target.attr("data-destinationUrlValue") : "") : hrefValue;

                var events = [{
                    "titleText": title.text(),
                    "elementText": $target.text(),
                    "destinationUrl": targetUrl
                }];

                if ($target.attr('href').indexOf('tel:') !== -1) {
                    $(this).trigger('telClick', [{ "titleText": title.text() }]);

                } else if ($target.text().indexOf('http') !== -1 || $target.hasClass("websiteLinkText")) {
                    $(this).trigger('websiteClick', events);

                } else if ($target.parent().parent().hasClass('info-window')) {
                    $(this).trigger(($target.data('analytics') === 'contact' || $target.hasClass('locationDetailsLink') || $target.text().indexOf("http") > -1 ? 'linkClick' : 'dirClick'), events);

                }
                else if ($target.hasClass('detailsTitleLink')) {
                    $(this).trigger('titleClick', events);
                } else if ($target.find('h6').length) {
                    $(this).trigger('linkClick', events);
                }

            } else if ($target.is('h6')) {
                $(this).trigger('linkClick', [{
                    "titleText": $target.text(),
                    "elementText": $target.text(),
                    "destinationUrl": $target.parent().attr('href')
                }]);
            }
        });
    }

